<mat-toolbar class="toolbar-container">
  <div class="toolbar-left">
  </div>

  <div class="toolbar-right">
    <div class="datetime-display">
      <div class="datetime-date">{{ currentDate }}</div>
      <div class="datetime-time">{{ currentTime }}</div>
    </div>

<div class="language-container flex flex mr-[20px] border-b-[1px_solid_#2a3661]">
<button class="language-button" (click)="switchLanguage('al')">
<img src="assets/images/i18n/al.png" alt="Albanian" class="language-img">
</button>
<button class="language-button" (click)="switchLanguage('en')">
<img src="assets/images/i18n/us.png" alt="English" class="language-img">
</button>
</div>

<button (click)="logout()" [title]="'TOOL_BAR.LOGOUT' | translate"  class="text-[#2a3661]">
<mat-icon class="material-symbols-outlined">logout</mat-icon>
</button>
  </div>
  
</mat-toolbar>